module.exports = __webpack_public_path__ + "img/icon_map_grey.2d3b5795.svg";